import React from 'react';

function DraftOrderStatusPills({ draftOrder, expired, expirationColorClass, expirationText, className = '' }) {
  if (!draftOrder) return null;

  return (
    <div className={`draft-order-status-container ${className}`}>
      

      {/* {draftOrder.taxExempt ? (
        <span className="pill-button pill-button-tax-exempt">
          Tax Exempt
        </span>
      ) : null} */}

      



      {draftOrder.order?.cancelledAt ? (
          <span className="pill-button draft-order-status pill-button-expired">Cancelled</span>
        ) : (
          <>
            

            {/* {draftOrder.declined ? (
              <span className="pill-button draft-order-status pill-button-red">Declined</span>
            ) : null }

            {draftOrder.approved ? (
              <span className="pill-button draft-order-status pill-button-green">Approved</span>
            ) : null}

            {draftOrder.needsUpdates ? (
              <span className="pill-button draft-order-status pill-button-purple">Updates Requested</span>
            ) : null}

            {draftOrder.needsExtension ? (
              <span className="pill-button draft-order-status pill-button-yellow">Extension Requested</span>
            ) : null} */}


            {!expired && draftOrder.status !== 'COMPLETED' && (draftOrder.status === 'PENDING' || draftOrder.status === 'OPEN_QUOTE') ? (
              <>
              <span className={`pill-button draft-order-status ${draftOrder.status === 'OPEN_QUOTE' ? 'pill-button-open' : draftOrder.status === 'PENDING' ? 'pill-button-invoice-sent' : 'pill-button-expired'}`}>
                {draftOrder.status.replace('_', ' ').toLowerCase()}
              </span>

              {draftOrder.approved ? (
                <span className="pill-button draft-order-status pill-button-green">Approved</span>
              ) : draftOrder.declined ? (
                <span className="pill-button draft-order-status pill-button-red">Declined</span>
              ) : draftOrder.needsUpdates || draftOrder.requestedUpdates ? (
                <span className="pill-button draft-order-status pill-button-purple">Updates Requested</span>
              ) : draftOrder.needsExtension ? (
                <span className="pill-button draft-order-status pill-button-yellow">Extension Requested</span>
              ) : null}
              </>
            ) : expired && draftOrder.status !== 'COMPLETED' ? (
              <span className="pill-button draft-order-status pill-button-expired">Expired Quote</span>
            ) : null}

            {/* {draftOrder.status === 'COMPLETED' ? (
              <span className="pill-button draft-order-status pill-button-completed">{draftOrder.status.toLowerCase()}</span>
            ) : null} */}

            {draftOrder.order ? (
              <>
                {draftOrder.order?.financialStatus === 'PENDING' ? (
                  <span className="pill-button draft-order-status pill-button-yellow">payment pending</span>
                ) : null}

                {draftOrder.order?.financialStatus === 'PAID' ? (
                  <span className="pill-button draft-order-status pill-button-green">paid</span>
                ) : null}

                {draftOrder.order?.financialStatus === 'PARTIALLY_REFUNDED' ? (
                  <span className="pill-button draft-order-status pill-button-pink">partially refunded</span>
                ) : null}

                {draftOrder.order?.financialStatus === 'PARTIALLY_PAID' ? (
                  <span className="pill-button draft-order-status pill-button-yellow">partially paid</span>
                ) : null}

                {draftOrder.order?.financialStatus === 'REFUNDED' || draftOrder.order?.financialStatus === 'VOIDED' ? (
                  <span className="pill-button draft-order-status pill-button-expired">{draftOrder.order?.financialStatus.replace('_', ' ').toLowerCase()}</span>
                ) : null}

                {draftOrder.order?.fulfillmentStatus === 'FULFILLED' || draftOrder.order?.fulfillmentStatus === 'OPEN' ? (
                  <span className="pill-button draft-order-status pill-button-blue">{draftOrder.order?.fulfillmentStatus.replace('_', ' ').toLowerCase()}</span>
                ) : null}

                {draftOrder.order?.fulfillmentStatus === 'PARTIALLY_FULFILLED' ? (
                  <span className="pill-button draft-order-status pill-button-orange">{draftOrder.order?.fulfillmentStatus.replace('_', ' ').toLowerCase()}</span>
                ) : null}

                {draftOrder.order?.fulfillmentStatus === 'UNFULFILLED' ? (
                  <span className="pill-button draft-order-status pill-button-grey">{draftOrder.order?.fulfillmentStatus.replace('_', ' ').toLowerCase()}</span>
                ) : null}

                



              </>
            ) : null}
          </>
      )}

      {draftOrder.expirationDate && !expired && draftOrder.status !== 'COMPLETED' ? (
        <span className={`pill-button ${expirationColorClass}`}>
          {expirationText}
        </span>
      ) : null}
    </div>
  );
}

export default DraftOrderStatusPills;
